import { GH, NG } from "@zenith/data/constants";
import { SendOtpDTO } from "@zenith/services/user";

/**
 * Maps the string country code to an enum value.
 * @function
 * @name countryCodeToEnum
 * @kind function
 * @param {string} countryCode The string country code.
 * @returns {SendOtpDTO.countryCode} A country code enum value.
 * @exports
 */
export function countryCodeToEnum(countryCode: string): SendOtpDTO.countryCode {
  switch (countryCode) {
    case NG:
      return SendOtpDTO.countryCode.NG;

    case GH:
      return SendOtpDTO.countryCode.GH;

    default:
      throw new Error("Country code not mapped");
  }
}
